/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsModule
 * Purpose		: Module for OrderDetails.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { OrderDetailsService } from './OrderDetails.service';
import { OrderDetailsListComponent } from './OrderDetailsList.component';
import { OrderDetailsSearchComponent } from './OrderDetailsSearch.component';
import { OrderDetailsAddComponent } from './OrderDetailsAdd.component';
import { OrderDetailsEditComponent } from './OrderDetailsEdit.component';
import { OrderDetailsDetailsComponent } from './OrderDetailsDetails.component';

import { OrderDetailsRoutingModule } from './OrderDetails-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    OrderDetailsRoutingModule
  ],
  declarations: [
    OrderDetailsListComponent,
	OrderDetailsSearchComponent,
    OrderDetailsEditComponent,
    OrderDetailsAddComponent,
	OrderDetailsDetailsComponent
  ],
  providers: [
    OrderDetailsService
  ]
})

export class OrderDetailsModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderDetails/OrderDetails.module.ts